import { BlockErrorMessage } from '../../../Block/BlockErrorMessage';
import { ButtonBase } from '../../../Button/ButtonBase';
import { ButtonText } from '../../../Button/ButtonText';
import { InnerButtonArea } from '../../../Layout/InnerLayout/InnerButtonArea';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';
import { TableBody } from '../../../Table/TableBody';
import { TableTrFormLabel } from '../../../Table/TableTr/TableTrFromLabel';
import { FormListPassword } from '../../FormList/FormListPassword';
import { InputText } from '../../InputText';

import type { InvalidParam } from '../../../../types/InvalidParam';
import type { FC, ChangeEventHandler, FormEventHandler } from 'react';

export type LoginInvalidParam = InvalidParam & {
  name: 'email' | 'password';
};

export type LoginInvalidParams = LoginInvalidParam[];

export type FormLoginProps = {
  invalidParams?: LoginInvalidParams;
  disableSubmitButton?: boolean;
  errorMessage?: string;
  eventHandlers?: {
    changeEmail: ChangeEventHandler<HTMLInputElement>;
    changePassword: ChangeEventHandler<HTMLInputElement>;
    submit: FormEventHandler<HTMLFormElement>;
  };
};

export const FormBlockLogin: FC<FormLoginProps> = ({
  invalidParams,
  disableSubmitButton,
  errorMessage,
  eventHandlers,
}) => {
  const emailError = invalidParams?.find((value) => value.name === 'email');
  const passwordError = invalidParams?.find(
    (value) => value.name === 'password',
  );

  return (
    <form method="post" onSubmit={eventHandlers?.submit}>
      <TableBody>
        <TableTrFormLabel
          id="email"
          required={true}
          errorMessage={emailError?.reason ? emailError?.reason : ''}
          title="メールアドレス（ID）"
        >
          <InputText
            name="email"
            id="email"
            type="email"
            width="default"
            placeholder="例)example@nurse-senka.jp"
            onChange={eventHandlers?.changeEmail}
          />
        </TableTrFormLabel>
        <TableTrFormLabel
          id="password"
          required={true}
          errorMessage={passwordError?.reason ? passwordError?.reason : ''}
          title="パスワード"
        >
          <FormListPassword onChange={eventHandlers?.changePassword} />
        </TableTrFormLabel>
      </TableBody>
      {errorMessage ? (
        <BlockErrorMessage>{errorMessage}</BlockErrorMessage>
      ) : (
        ''
      )}
      <InnerButtonArea>
        <InnerMargin align="center">
          <ButtonBase
            color="primary"
            width="extend"
            disable={disableSubmitButton === true}
          >
            ログインする
          </ButtonBase>
        </InnerMargin>
        <InnerMargin align="center">
          <ButtonText
            color="default"
            link="/passwords/reset"
            useNextLink={true}
          >
            パスワードをお忘れの方
          </ButtonText>
        </InnerMargin>
      </InnerButtonArea>
    </form>
  );
};
